import { Product, ProductVariant } from '@shopify/hydrogen-react/storefront-api-types';
import classNames from 'classnames';
import React from 'react';
import ProductPriceFormatted from './ProductPriceFormatted';

interface Props {
  className?: string;
  product: Product;
  selectedVariant: ProductVariant;
}

const ProductTopMeta: React.FC<Props> = ({ className, product, selectedVariant }) => {
  return (
    <div
      className={classNames(
        {
          'product-single-meta': true,
        },
        className
      )}
    >
      {process.env.REACT_APP_FEATURE_PRODUCT_TAGS === 'true' &&
        product &&
        product.tags?.includes('New Arrivals') && (
          <div className="product-tag-new tag-primary">New</div>
        )}
      <h1 className="product-title">{product?.title}</h1>
      {selectedVariant && <ProductPriceFormatted data={selectedVariant as ProductVariant} />}
    </div>
  );
};

export default ProductTopMeta;
